<template>
	<div class="row">
		<div class="col-md-5">
			<card header-classes="bg-dark">
				<template slot="header">
					<h3 class="mb-0 text-white">ตั้งค่ากงล้อ</h3>
				</template>
				<form @submit.prevent="submitSave">
					<base-checkbox v-model="enable" class="mb-3">
						เปิดใช้งาน
					</base-checkbox>

					<div class="row">
						<div class="col-md-6">
							<base-input label="ประเภทรางวัล">
								<el-select
									v-model="rewardType"
									placeholder="ประเภทรางวัล"
								>
									<el-option
										v-for="(v, k) in rewardTypes"
										:key="k"
										:value="k"
										:label="v.name"
									/>
								</el-select>
							</base-input>
						</div>
						<div class="col-md-6">
							<base-input label="จำกัดการเล่น">
								<el-select
									v-model="rewardLimit"
									placeholder="จำกัดการเล่น"
								>
									<el-option
										value="every_hour"
										label="เล่นได้ทุก 1 ชั่วโมง"
									/>
									<el-option
										value="every_day"
										label="เล่นได้ทุกวัน"
									/>
									<el-option
										value="every_week"
										label="เล่นได้ทุกสัปดาห์"
									/>
									<el-option
										value="every_month"
										label="เล่นได้ทุกเดือน"
									/>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="row">
						<div class="col-md-4">
							<base-input
								label="ยอดฝากขั้นต่ำ"
								placeholder="ยอดฝากขั้นต่ำ"
								v-model.number="minDeposit"
							/>
						</div>
						<div class="col-md-4">
							<base-input
								label="เทิร์น"
								placeholder="เทิร์น"
								v-model.number="rewardTurn"
							/>
						</div>
						<div class="col-md-4">
							<base-input label="ประเภทยอดฝาก">
								<el-select
									placeholder="ประเภทยอดฝาก"
									v-model="depositType"
								>
									<el-option value="sum" label="ยอดฝากรวม" />
									<el-option
										value="tx"
										label="ยอดฝากรายครั้ง"
									/>
								</el-select>
							</base-input>
						</div>
					</div>

					<div class="form-row mt-3">
						<div
							class="col-md-3 col-6"
							v-for="v in reward.rewards"
							:key="v.key"
						>
							<base-input
								:label="v.name"
								:placeholder="v.name"
								required
								v-model.number="v.chance"
							>
								<template slot="append">
									<span>%</span>
								</template>
							</base-input>
						</div>
						<div class="form-group col-md-12">
							<label>ยอดรวม: {{ sumRewardPrecent }}%</label>
						</div>
					</div>

					<div class="form-group mb-3">
						<label class="form-control-label"
							>เงื่อนไขกงล้อเสี่ยงโชค</label
						>
						<base-checkbox v-model="rules.noWithdraw" class="mb-2">
							ต้องไม่มีรายการถอน (ของรายการฝาก)
						</base-checkbox>
						<base-checkbox v-model="rules.noBonus" class="mb-2">
							ต้องไม่มีรายรับโบนัส (ของรายการฝาก)
						</base-checkbox>
						<base-checkbox v-model="rules.minCredit" class="mb-2">
							ต้องมีเครดิตคงน้อยกว่าหรือเท่ากับ {{ minCredit }}
						</base-checkbox>
					</div>

					<base-button
						native-type="submit"
						type="default"
						class="mt-2"
						:disabled="loading"
					>
						บันทึกข้อมูล
					</base-button>
				</form>
			</card>
		</div>
	</div>
</template>

<script>
import { Select, Option } from 'element-ui'

import WheelService from '../services/wheel.service'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,

			enable: false,
			rewardType: '',
			rewardTurn: 0,
			rewardLimit: '',
			minDeposit: 0,
			depositType: '',
			rules: {},
			minCredit: 0,
			rewardTypes: {
				type1: {
					name: 'ประเภทที่ 1',
					rewards: {
						'50b': {
							name: '50 บาท',
							amount: 50,
							chance: 0,
							index: 1,
						},
						'100b': {
							name: '100 บาท',
							amount: 100,
							chance: 0,
							index: 2,
						},
						'150b': {
							name: '150 บาท',
							amount: 150,
							chance: 0,
							index: 3,
						},
						'200b': {
							name: '200 บาท',
							amount: 200,
							chance: 0,
							index: 4,
						},
						'250b': {
							name: '250 บาท',
							amount: 250,
							chance: 0,
							index: 5,
						},
						'300b': {
							name: '300 บาท',
							amount: 300,
							chance: 0,
							index: 6,
						},
						'500b': {
							name: '500 บาท',
							amount: 500,
							chance: 0,
							index: 7,
						},
						'1000b': {
							name: '1,000 บาท',
							amount: 1000,
							chance: 0,
							index: 8,
						},
						'2000b': {
							name: '2,000 บาท',
							amount: 2000,
							chance: 0,
							index: 9,
						},
						gold: {
							name: 'ทอง 1 บาท',
							amount: 0,
							chance: 0,
							index: 10,
						},
					},
				},
				type2: {
					name: 'ประเภทที่ 2',
					rewards: {
						'5b': { name: '5 บาท', amount: 5, chance: 0, index: 1 },
						'10b': {
							name: '10 บาท',
							amount: 10,
							chance: 0,
							index: 2,
						},
						'15b': {
							name: '15 บาท',
							amount: 15,
							chance: 0,
							index: 3,
						},
						'20b': {
							name: '20 บาท',
							amount: 20,
							chance: 0,
							index: 4,
						},
						'25b': {
							name: '25 บาท',
							amount: 25,
							chance: 0,
							index: 5,
						},
						'50b': {
							name: '50 บาท',
							amount: 50,
							chance: 0,
							index: 6,
						},
						'100b': {
							name: '100 บาท',
							amount: 100,
							chance: 0,
							index: 7,
						},
						'200b': {
							name: '200 บาท',
							amount: 200,
							chance: 0,
							index: 8,
						},
						'300b': {
							name: '300 บาท',
							amount: 300,
							chance: 0,
							index: 9,
						},
						gold: {
							name: 'ทอง 1 บาท',
							amount: 0,
							chance: 0,
							index: 10,
						},
					},
				},
			},
		}
	},
	computed: {
		reward() {
			return this.rewardTypes[this.rewardType] || []
		},
		sumRewardPrecent() {
			return Object.values(this.reward.rewards || []).reduce(
				(val, x) => val + x.chance,
				0
			)
		},
	},
	methods: {
		async submitSave() {
			if (this.sumRewardPrecent !== 100) {
				this.$notify({
					type: 'danger',
					message: 'ยอดรวมเปอร์เซ็นต้องเท่ากับ 100%',
				})
				return false
			}

			try {
				this.loading = true
				const { message } = await WheelService.updateSetting({
					enable: this.enable,
					rewardType: this.rewardType,
					rewardLimit: this.rewardLimit,
					rewardTurn: this.rewardTurn,
					minDeposit: this.minDeposit,
					depositType: this.depositType,
					rules: this.rules,
					rewards: this.reward.rewards || {},
				})
				this.$notify({ type: 'success', message })
			} catch ({ message }) {
				this.$notify({ type: 'danger', message })
			} finally {
				this.loading = false
			}
		},
	},
	created() {
		WheelService.fetchSetting().then((res) => {
			this.enable = res.setting.enable
			this.rewardType = res.setting.rewardType
			this.rewardTurn = res.setting.rewardTurn
			this.rewardLimit = res.setting.rewardLimit
			this.minDeposit = res.setting.minDeposit
			this.depositType = res.setting.depositType
			this.rules = res.setting.rules
			this.minCredit = res.minCredit

			if (res.setting.rewards) {
				const rewards = this.rewardTypes[res.setting.rewardType].rewards
				for (let x of Object.keys(rewards)) {
					if (rewards.hasOwnProperty(x)) {
						rewards[x].chance = res.setting.rewards[x].chance
					}
				}
			}
		})
	},
}
</script>
